import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalPasswordService } from './modal-password.service';
import { LoginService } from '../../injections/login.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';


@Component({
    selector: 'modal-password',
    templateUrl: 'modal-password.html'
})

export class ModalPasswordComponent implements OnInit {
    public showModal;
    public passwordData: FormGroup;
    public idUser;
    public passwordError = false;
    public newPassError = false;
    @ViewChild('passwordModal') public passwordModal:ModalDirective;
    constructor(private modalPasswordService: ModalPasswordService,private loginService: LoginService, private _fb: FormBuilder) { }

    public onHidden():void{
       this.passwordModal.hide()
    }

    public closeModal():void{
       this.passwordModal.hide()
    }

    public changePassword() {
        var data = {
            id: this.idUser,
            oldPassword: this.passwordData.value.oldPass,
            newPassword: this.passwordData.value.newPass
        }
        this.loginService.updatePassword(data).subscribe(result => {
            //console.log(result);
            if(result == "OK"){
                this.passwordModal.hide();
                this.passwordError = false;
            }else{
                this.passwordError = true;
            }
        });
    }

    public checkNewPassword() {
        if(this.passwordData.controls.newPass.valid && this.passwordData.controls.newPass2.valid){
            if(this.passwordData.controls.newPass.value != this.passwordData.controls.newPass2.value){
                this.newPassError = true;
                this.passwordData.controls['newPass2'].setErrors({'incorrect': true});
            }else{
                this.newPassError = false;
                this.passwordData.controls['newPass2'].setErrors(null);
            }
        }
    }

    ngOnChanges(value) {
        (this.showModal) ? this.passwordModal.show() : this.passwordModal.hide();
    }

    ngOnInit() { 
        
         this.modalPasswordService.getModalListener().subscribe(data => { 
            this.idUser = data["id"];
            this.passwordModal.show()
        });

         this.passwordData = this._fb.group({
            oldPass: ['', [Validators.required, Validators.minLength(4)]],
            newPass: ['', [Validators.required,Validators.minLength(4)]],
            newPass2: ['', [Validators.required, Validators.minLength(4)]]
        });
         this.passwordData.valueChanges.subscribe(data => {
                this.checkNewPassword();
         });
    }
}


// WEBPACK FOOTER //
// ./src/app/common/modal-password/modal-password.component.ts